<form [formGroup]="settlorForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin" style="margin-bottom: 15px; margin-top: 15px;">{{ formTitle }}</h1>

    <p class="lead rocal">{{ formSubtitle }}</p>

    <div formArrayName="settlors">
      <div *ngFor="let settlor of getSettlors().controls; let i=index" [formGroupName]="i" style="position: relative;">

        <div style="height: 40px;" *ngIf="i > 1"></div>
        <p style="font-weight: 600; font-size: 1.3em;" class="blue margin">{{'Contact ' + (i+1)}} </p>

        <div class="flex blue-box" *ngIf="settlors[i] && !settlors[i].verified">
          <p class="blue lead">
            {{ contactInfoTitle }}
          </p>
          <div class="line-2"></div>

          <div class="row-alt">
            <div class="row-mini">
              <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Title" label={{titleLabel}}
                hint={{titleHint}} inputType="auto-complete" required="false" [loadingOptions]="loadingTitles"
                [ArrayItems]="TitleOptions" [validationMessages]="validationMessages" [formErrors]="formErrors">
              </app-input>

              <app-input [formGroup]="getSettlorFormGroup(i)" controlName="FirstName" label={{fNameLabel}}
                hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>

            <div class="row-mini">
              <app-input [formGroup]="getSettlorFormGroup(i)" controlName="MiddleName" label={{mNameLabel}}
                hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="getSettlorFormGroup(i)" controlName="LastName" label={{surnameLabel}}
                hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>
          </div>

          <div class="row" style="margin-top: 30px;">
            <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Phone" class="grid-item"
              label={{phoneLabel}} inputType="phone"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getSettlorFormGroup(i)" controlName="SecondaryPhone" class="grid-item" *ngIf="region === 1"
              label="Secondary Phone Number" inputType="phone"
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <!-- Kenya only email input -->
            <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item" controlName="Email" label={{emailLabel}} *ngIf="region == 0"
              hint={{emailLabel}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>
          <!-- Diaspora email input -->
          <div class="row half" style="margin-top: 30px;" *ngIf="region === 1">
            <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item" controlName="Email" label={{emailLabel}}
              hint={{emailLabel}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div class="flex done-box" *ngIf="settlors[i] && settlors[i].verified">
          <p class="light-blue lead">
            {{ contactInfoTitle }}
          </p>
          <div class="flex checker-circle">
            <img src={{checkerPath}} class="checker" alt="logo" />
          </div>
        </div>

        <div class="remove-button" *ngIf="i > 0">
          <button mat-stroked-button type="button" (click)="removeSettlor(i)">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{ getSettlors().controls.length-1 === i ? removeButtonText : removeSettlorText }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>
        </div>
      </div>

      <!-- BUTTTON Add Settlor -->
      <div class="blueStroke row" [ngClass]="{'min-55' : getSettlors().length > 1}">
        <button mat-stroked-button *ngIf="settlors[settlors.length-1] && settlors[settlors.length-1].done === true"
          [disabled]="loading || loadingRemove" class="general-stroked-button" type="button" (click)="addNewSettlor()">
          <span class="button-text">
            {{ addSettlorText }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService" [text]="
            loading ? loadingText :
            settlors[settlors.length-1] && settlors[settlors.length-1].done == true ? 'Next' :
            settlors[settlors.length-1] && settlors[settlors.length-1].verified == false ? 'Verify via OTP' :
            'Save Details'
        " [formValid]="
            (
                settlors[settlors.length-1] &&
                settlors[settlors.length-1].done &&
                settlors[settlors.length-1].done == true
            ) ? true :
            settlorForm.valid ? true : false
        " [showContinue]="'false'" [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>